module.exports = __webpack_public_path__ + "static/media/3project.adfd63f7.jpeg";